import { render, staticRenderFns } from "./InputSampleDashboard.vue?vue&type=template&id=b39f03c0&scoped=true"
import script from "./InputSampleDashboard.vue?vue&type=script&lang=js"
export * from "./InputSampleDashboard.vue?vue&type=script&lang=js"
import style0 from "./InputSampleDashboard.vue?vue&type=style&index=0&id=b39f03c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b39f03c0",
  null
  
)

export default component.exports